import { createSurveyStyles } from '@sm/webassets';
import { WrenchTheme } from '@wds/styles';
import { SurveyThemeType } from '@sm/webassets/dist/components/SurveyTheme';

type SurveyStyleNames =
  | 'surveyHeaderContainer'
  | 'surveyToolbarContainer'
  | 'surveyTitleContainer'
  | 'pageHeaderContainer'
  | 'layoutMainContainer'
  | 'questionContainer'
  | 'pageFooterContainer'
  | 'surveyFooterContainer'
  | 'sronlyFocus'
  | 'pageNavigationContainer';

type SurveyStyleProps = { offsetTop: number; offsetBottom: number };
const useStyles = createSurveyStyles<SurveyStyleNames, SurveyStyleProps>((theme: SurveyThemeType) => ({
  '@global': {
    // body reset - same as previous wds-reset styles
    body: {
      fontFamily: WrenchTheme.type.fontFamily.base,
      '-webkit-font-smoothing': 'antialiased',
      fontSize: '15px',
      boxSizing: 'border-box',
      padding: 0,
      margin: 0,
      listStyle: 'none',
    },
  },
  // Document banner container
  surveyHeaderContainer: {},
  // Exit-link container
  surveyToolbarContainer: {},
  // Survey Title container
  surveyTitleContainer: {},
  // Page Header container
  pageHeaderContainer: {},
  // Main container
  layoutMainContainer: {
    marginTop: ({ offsetTop }) => `${offsetTop}px`,
  },
  // Form
  questionContainer: {},
  // Page Footer Container
  pageFooterContainer: {
    margin: [30, 0, 24],
  },
  pageNavigationContainer: {},
  // May not be used
  // Page description OK button
  sronlyFocus: {
    '&:not(:focus)': {
      clip: 'rect(1px, 1px, 1px, 1px)',
      clipPath: 'inset(50%)',
      height: '1px',
      width: '1px',
      margin: '-1px',
      overflow: 'hidden',
      padding: 0,
    },
  },
  surveyFooterContainer: {
    padding: [40, 0],
    marginBottom: ({ offsetBottom = 0 }) => `${offsetBottom}px`,
  },
}));

export default useStyles;
